export default __webpack_public_path__ + "static/therapy-8c40e549247c5bf9f4c12fc1cc35aa5c.svg";